import React, { ReactElement } from 'react';
import styles from './TopologyTitle.module.css';

export type TopologyTitleProps = {
  title: string;
  overrideClasses?: string;
};

export function TopologyTitle({
  title,
  overrideClasses,
}: TopologyTitleProps): ReactElement {
  return (
    <div
      className={overrideClasses ? overrideClasses : styles.topologyTitle}
      title={title}
    >
      {title}
    </div>
  );
}
